let scrollTimeout;
let throttle = 50;

document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.site-header');
    if (!header) {
        return;
    }

    window.addEventListener('scroll', () => {
        if (scrollTimeout) {
            return;
        }
    
        if(window.scrollY > 50) {
            if(!header.classList.contains('--page-scrolled')) {
                header.classList.add('--page-scrolled');
            }
        } else {
            header.classList.remove('--page-scrolled');
        }
    
        scrollTimeout = setTimeout(function () {
            scrollTimeout = null;
        }, throttle);
    });
})